<template>
<div>
  <v-layout  v-if="loginDialog" style="padding-top: 150px;">
    <v-flex xs12 sm12 md12 lg12>
      <div>
        <v-card class="mx-auto" max-width="500" outlined style="border-radius: 20px;"
        >
          <v-img :src="require('../assets/splash.jpg')" style="border-radius: 20px;"/>
          <v-overlay
            opacity="0.6"
            absolute
            color="black"
            style="padding: 10px;"
          >
          <v-card-title class="justify-center"><h3>{{title}}</h3></v-card-title>
          <v-divider />
          <p>{{msg}}</p>
          <ValidationObserver ref="observer" >
            <ValidationProvider
              name="email"
              ref="email"
              rules="required"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
                prepend-icon="person"
                v-model="email"
                label="Email"
                outlined
                autofocus
                v-on:keyup.enter="submit"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <ValidationProvider
              name="password"
              ref="password"
              rules="required|customPassword"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
                v-if="!resetPassword"
                prepend-icon="lock"
                class="mt-5"
                v-model="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'"
                label="Password"
                counter
                @click:append="show1 = !show1"
                outlined
                v-on:keyup.enter="submit"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn :disabled="!valid" @click="signIn()" text>Login</v-btn> -->
              <v-btn :disabled="!valid" @click="submit()" text>{{ resetPassword ? 'Reset' : 'Login'}}</v-btn>
              <v-btn @click="cancel" text>cancel</v-btn>
          <v-btn v-if="!resetPassword" text @click="forgot">Reset Password</v-btn>
            </v-card-actions>
          </ValidationObserver>
          </v-overlay>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import {ValidationProvider, extend} from "vee-validate/dist/vee-validate.full"
import { ValidationObserver } from "vee-validate/dist/vee-validate.full"
import { sync } from "vuex-pathify"
import axiosInstances from '../server/axiosInstances'
extend("required", {
  message: (field, values) => "You must enter a " + `${field}` + " value",
});
// create custom error message for custom rule
var errorMessage =
  " min length 8 chars, and must include 1 lower-case, upper-case, numeral and special character (#!@$%^*-)";
// create custom rule
extend("customPassword", {
  message: (field) => "The " + `${field}` + errorMessage,
  validate: (value) => {
    var notTheseChars = /["'?&/<>\s]/;
    var mustContainTheseChars = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@$%^*-]).{8,}$/;
    var containsForbiddenChars = notTheseChars.test(value);
    // var containsRequiredChars = mustContainTheseChars.test(value);
    if (/*containsRequiredChars &&*/ !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        errorMessage =
          ' contains forbidden characters: " ' + " ' ? & / < > or space";
      } else {
        errorMessage =
          " min length 8 chars, and must include 1 lower-case,upper-case, numeral and special character ($@$!%*#?&)";
      }
      return false;
    }
  },
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    show1: false,
    email: "",
    password: "",
    title: "Login to Entrinsia Cortex",
    msg: "Passwords are case sensitive",
    resetPassword: false,
  }),
  computed: {
    loginDialog: sync('login/loginDialog'),
    loggedIn: sync('login/loggedIn'),
    loggedinUser: sync('login/loggedinUser'),
    loginFailed: sync('login/loginFailed'),
    loginActions: sync('login/loginActions'),
    loginError: sync('login/loginError'),
    loginMessage: sync('login/loginMessage'),
    valid() {
      return (this.resetPassword ?  this.email != '' : this.password != '' && this.email != '')
    },
  },
  methods: {
    async requestResetPassword() {
      console.log("reset password was requested");
      var self = this;
      try {
        let ret = await axiosInstances.loginServer.get('/auth/sendPasswordResetMail?email=' + this.email)
      } catch (ex) {
        console.log(ex)
      }
      this.clear();
      this.msg =
        "If you are an authorized user, a password reset link has been sent to your email account. If you don't see a password reset email from Entrinsia, please check your spam folders. For further assistance, please contact support@entrinsia.com.";
        this.title = "Login to Entrinsia Cortex"
    },

    async submit () {
      this.msg = '' // "Logging in..."
      if (this.resetPassword) {
        this.requestResetPassword()
      } else {
        try {
        await this.$store.dispatch('login/doLogin', {
          email: this.email,
          password: this.password
        })
        } catch (ex) {
          console.log('caught in login: ', ex) 
          this.msg = "Login error, please try again"
        }
        // this.loginDialog = false
      }
      // this.msg = ""
    },
    clear() {
      this.email = "";
      this.password = "";
      this.msg = "Passwords are case sensitive";
      this.resetPassword = false;
      this.title = "Login to Entrinsia Cortex";
    },
    cancel() {
      this.clear();
      this.loginDialog = false;
    },
    forgot() {
      this.resetPassword = true;
      this.title = "Reset Password";
      this.msg =
        'Enter Email and click "Reset" to receive email link to reset password.';
    },
  },
  watch: {
    loginFailed(val) {
      if (val) {
        this.loginDialog = true
        this.msg = "Login failed, please try again. If you forgot your password please reset it by clicking 'Reset Password'."
        this.loginFailed = false
        if (!navigator.onLine) {
          this.msg += ' (Network is disconnected)'
        } else {
          if (this.loginError == null) {
            this.msg = ' Servers unreachable. Please try again later. '
            this.msg += 'If error persists please contact support@entrinsia.com'
          } else {
            // this.msg = this.loginError
          }
        }
      }
    },
    loggedIn(val) {
      if (val) {
        if (this.loginActions) this.loginActions()
        this.loginDialog = false
        // this.elog('log', 'Login succeded for {}', this.loggedinUser.email)()
      } else {
        this.clear()
      }
    }
  },
  mounted() {
    this.clear()
    this.title = "Login to Entrinsia Cortex"
    this.msg = this.loginMessage == null || this.loggedinMessage == '' ? "Passwords are case sensitive" :
      this.loginMessage
  },
};
</script>
